'use client';

import { useEffect, useRef, useState } from 'react';

import IconClose from '@/assets/icons/iconClose.svg';

/** Плашки внизу экрана ждут это событие, чтобы не накладываться на cookies */
export const COOKIES_ACCEPTED_EVENT = 'cookiesAccepted';

interface CookiesProps {
  cookiesDisclaimer: string;
}

export const Cookies = ({ cookiesDisclaimer }: CookiesProps) => {
  const cookiesRef = useRef<HTMLDivElement>(null);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const acceptedCookies = localStorage.getItem('cookiesAccepted');

    setIsVisible(acceptedCookies !== 'true');
  }, []);

  const handleCookiesAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    window.dispatchEvent(new Event(COOKIES_ACCEPTED_EVENT));

    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      ref={cookiesRef}
      className="rounded-20 bg-surface-base-secondary fixed right-0 bottom-14 left-0 z-[100] m-auto flex max-w-[798px] items-center justify-between gap-2 px-9 py-6 text-sm leading-[1.125rem] max-sm:bottom-4 max-sm:mx-4 max-sm:items-start max-sm:px-5 max-sm:py-6 max-sm:text-sm"
    >
      <p
        dangerouslySetInnerHTML={{
          __html: cookiesDisclaimer,
        }}
      />
      <button
        role="button"
        onClick={handleCookiesAccept}
        aria-label="close"
        className="bg-surface-base-blur flex h-12 w-12 cursor-pointer items-center justify-center rounded-xl p-3 max-sm:h-10 max-sm:w-10 max-sm:p-2"
      >
        <IconClose className="text-text-base-primary h-6 w-6" />
      </button>
    </div>
  );
};
